import React from 'react';
import PropTypes from 'prop-types';
import FormSelect from '../FormSelect';

const propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

const AccountTypeSelector = ({ name, options, ...rest }) => (
    <FormSelect
      name={name}
      label="Account Type"
      options={options}
      {...rest}
    />
);

AccountTypeSelector.propTypes = propTypes;

export default AccountTypeSelector;
